<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.thirdparty.text") }}</h1>

      <div role="tablist">
        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.thirdparty.line-1") }}
            </p>

            <img src="@/assets/images/help/thirdparty.png" class="image" />

            <p class="mb-3 mt-3">
              {{ $t("help.platform.thirdparty.line-2") }}
            </p>

            <img src="@/assets/images/help/create-thirdparty.png" class="image" />

            <p class="mt-3 mb-3">
              {{ $t("help.platform.thirdparty.line-3") }}
            </p>

            <p>
              {{ $t("help.platform.thirdparty.line-4") }}
            </p>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
